export namespace ImportTranslations {
  export const error = {
    exportConfigurationWithNameAlreadyExistsForEntityType: 'exportConfigurationWithNameAlreadyExistsForEntityType',
  } as const;
}
